import './styles.scss';
import { useContext } from 'react';
import { InvitationContext } from '../invitation-context';
import Loading from '../../../../common/loading';
import l from '../../../../../lang';
import { MailOutline } from '@mui/icons-material';
import { Avatar } from '@mui/material';
import Parser from 'html-react-parser';

export const DialogInviteStep3 = () => {
  const { state } = useContext(InvitationContext);
  return (
    <div className="step3_container_success" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 320, background: '#fff' }}>
      {state.loading && <Loading />}
      {!state.loading && (
        <>
          <Avatar
            sx={{
              width: 72,
              height: 72,
              bgcolor: '#e3eafc',
              color: '#3272f0',
              margin: '0 auto',
            }}
          >
            <MailOutline sx={{ fontSize: 36 }} />
          </Avatar>
          <h3 style={{ marginTop: 24 }}>{l('userManagement.inviteSuccess')}</h3>
          <p style={{ marginBottom: 32, textAlign: 'center' }}>
            {Parser(l('userManagement.inviteSuccess.message', state.email, String(l('roles.' + state.role)).toLowerCase()))}
          </p>
          {}
        </>
      )}
    </div>
  );
};
